import { LoadingOverlay, Tabs } from "@mantine/core";
import { useAttachmentList } from "../../../../hooks/react-query/useAttachmentList";
import { Fragment, useEffect, useState } from "react";
import { StyledTabs } from "../../../UI/tabs/StyledTabs";
import { CustomerAttachment } from "../../../../constants/model/models";
import { useUser } from "../../../../hooks/react-query/useUser";
import { useTranslation } from "next-i18next";
import { useProcessingStore } from "../../../config/store/usProccessingStore";

export function AttachmentTabs() {
  const {
    attachmentData,
    getCategoryList,
    getCategoryAttachments,
    getFileName,
    downloadAttachment,
  } = useAttachmentList();
  const [categories, setCategories] = useState<string[]>([]);
  const { user } = useUser();
  const { t } = useTranslation("common");
  const { processing } = useProcessingStore((state) => state);

  useEffect(() => {
    if (attachmentData) {
      setCategories(getCategoryList(attachmentData));
    }
  }, [attachmentData]);

  function renderTab(value: string) {
    let tabLabel = value;
    if (tabLabel === "###") tabLabel = t("documents.misc");
    return <Tabs.Tab value={value}>{tabLabel}</Tabs.Tab>;
  }

  function renderPanel(value: string) {
    return (
      <div className="p-4">
        {
          // @ts-ignore
          getCategoryAttachments(attachmentData, value).map((attachment) => {
            return (
              <div className="my-2" key={attachment.link}>
                {renderLink(attachment)}
              </div>
            );
          })
        }
      </div>
    );
  }

  function renderLink(attachment: CustomerAttachment) {
    return (
      <a
        onClick={() => downloadAttachment(attachment)}
        href="#"
        style={{
          color: "blue",
          fontSize: "1.5rem",
          textDecoration: "underline",
        }}
      >
        {getFileName(attachment)}
      </a>
    );
  }

  return (
    <Fragment>
      <LoadingOverlay visible={processing} />
      {categories.length > 0 && attachmentData && user && (
        <div className="flex justify-center">
          <StyledTabs defaultValue={categories[0]}>
            <Tabs.List>
              {categories.map((category: string) => {
                return renderTab(category);
              })}
            </Tabs.List>
            {categories.map((category: string) => {
              return (
                <Tabs.Panel key={category} value={category}>
                  {renderPanel(category)}
                </Tabs.Panel>
              );
            })}
          </StyledTabs>
        </div>
      )}
    </Fragment>
  );
}
